import store from '@/vuex';
import CONFIG from '@/config';
import {
  openChannelsLive,
  openChannelsUserProfile,
  reserveChannelsLive,
} from '@/utils/openChannelsLive';
function to(url) {
  uni.navigateTo({
    url,
  });
}

function back({ delta = 1, success = function() {}, fail = function() {} } = { delta: 1 }) {
  uni.navigateBack({ delta, success, fail });
}

function redirect(url, option) {
  uni.redirectTo({
    url,
    ...option,
  });
}

function switchTab(url, option) {
  // 处理小程序跳tabbar页面，参数自动被屏蔽，先存起来
  const query = url.split('?')[1];
  if (query) {
    uni.setStorageSync('tabbar_query', query);
  }
  uni.switchTab({
    url,
    ...option,
  });
}

function reLaunch(url, option) {
  uni.reLaunch({
    url,
    ...option,
  });
}

const toPage = function(action, data, option = {}) {
  action = typeof action === 'number' ? action.toString() : action;
  let url = '';
  switch (action) {
    case '0':
      switchTab('/pages/index');
      break;
    case '1': {
      // 外部H5链接
      url = `/pages/web?url=${encodeURIComponent(data)}`;
      break;
    }
    case '2': // 普通商品详情
      url = `/pages/goods/goods?id=${data}`;
      break;
    case '5': // 登录
      url = '/pages/login/login';
      break;
    case '6': {
      // 个人中心
      switchTab('/pages/mine');
      break;
    }
    case '15': // 购物车
      switchTab(`/pages/cart`);
      break;
    case '26': // 确认订单-立即购买指定商品
      url = '/pages/order/checkout';
      break;
    case '27': {
      // 订单详情
      url = `/pages/order/detail?id=${data}`;
      break;
    }
    case '28': {
      // 评价订单
      url = `/pages/order/comments?id=${data}`;
      break;
    }
    case '30': // 退款详情
      url = `/pages/refund/refund-type-selection?id=${data}`;
      break;
    case '32': // 退款详情
      url = `/pages/order/refund-detail?id=${data}`;
      break;
    case '40': {
      // 编辑个人资料
      url = '/pages/user/user_info';
      break;
    }
    case '47': // 我的现金券
      url = '/pages/coupon/list';
      break;
    case '56': {
      // 会员（我的会员）
      switchTab('/pages/member');
      break;
    }
    case '57': {
      // 我的U币（我的余额）
      url = '/pages/account/credit';
      break;
    }
    case '60': {
      // 搭配减价清单
      url = '/pages/goods/match-list';
      break;
    }
    case '61': {
      // 搭配减价详情
      url = `/pages/goods/match-detail?id=${data}`;
      break;
    }
    case '62': {
      // 签到
      url = '/pages/sign/sign';
      break;
    }
    case '65': {
      // 兑换专区
      url = '/pages/exchange/code';
      break;
    }
    case '73': {
      // 我的卡券
      url = '/pages/goods/coupon/my-coupon';
      break;
    }
    case '74': {
      // 我的卡券-包邮卡
      url = '/pages/coupon/list';
      break;
    }
    case '76': {
      // 团购活动列表
      url = '/pages/groupon/list';
      break;
    }
    case '77': // 团购商品详情
      url = `/pages/groupon/goods-detail?id=${data}`;
      break;
    case '78': {
      // 团购活动详情
      url = `/pages/groupon/detail?coopId=${data}`;
      break;
    }
    case '81': // 分享金商品详情
      url = `/pages/commission/goods-detail?id=${data}`;
      break;

    case '84': // 预售商品详情
      url = `/pages/presale/goods-detail?id=${data}`;
      break;
    case '85': // 限时抢购商品详情
      url = `/pages/limited-sale/goods-detail?id=${data}`;
      break;
    case '1001': // 搜索结果页
      url = `/pages/goods/search_result?keywords=${data}`;
      break;
    case '1004': // 小程序手机号登录
      url = '/pages/login/login-mobile';
      break;
    case '1005': // 小程序授权页 type=1' 授权获取用户信息  type=2' 授权获取手机号
      url = `/pages/auth?type=${data}`;
      break;
    case '1007': // 券详情
      url = '/pages/coupon/detail';
      break;
    case '1008': // 订单列表
      url = '/pages/order/list';
      if (data) {
        url += `?tab=${data}`;
      }
      break;
    case '1009': // 红包抽奖
      url = '/pages/lottery/redpack/lottery';
      break;
    case 'memberContract': {
      // 会员开通协议
      let link = '';
      link = CONFIG.IS_PROD
        ? 'https://syoung.syounggroup.com/pages/member/contract'
        : 'https://testsoyoung.syounggroup.com/pages/member/contract';
      url = `/pages/webView?link=${encodeURIComponent(link)}`;
      break;
    }
  }
  if (url) {
    option.isRedirect ? redirect(url) : to(url);
  }
};

function isEmptyString(str) {
  return !str || !str.trim();
}

function toLocation(item, useRedirect) {


















  if (item.jumpData && item.jumpData.type === 'alipayLink') {





    return;
  }
  if (item.jumpData && item.jumpData.type === 'alipayBenefitLink') {
    const { pluginId = '' } = item.jumpData || {};








    return;
  }
  if (item.jumpData && item.jumpData.type === 'custom') {

    if (!isEmptyString(item.jumpData.webLink)) {
      location.href = item.jumpData.webLink;
      return;
    }

    // 参数里有needLogin，则需要校验登录
    if (item?.jumpData?.miniLink?.includes('needLogin') && !store.getters.isLogin) {
      toPage('5');
      return;
    }








    if (!isEmptyString(item.jumpData.miniLink)) {
      if (miniLinkIsTabPage(item.jumpData.miniLink)) {
        switchTab(item.jumpData.miniLink);
      } else {
        useRedirect ? redirect(item.jumpData.miniLink) : to(item.jumpData.miniLink);
      }
    } else if (!isEmptyString(item.jumpData.webLink)) {
      // webLink
      // 免登陆领奖活动页用to方法
      const url = item?.jumpData.webLink.split('com')[1];
      if (miniLinksActiveyPage(item?.jumpData.webLink)) {
        to(url);
        return;
      }
      const encodeUrl = encodeURIComponent(item.jumpData.webLink);
      useRedirect
        ? redirect(`/pages/webView?link=${encodeUrl}`)
        : to(`/pages/webView?link=${encodeUrl}`);
    }
  } else if (item.mini_location) {
    const { pathname, search, appId } = item.mini_location;
    if (appId) {
      toOtherAppLocation({
        jumpData: item.mini_location,
      });
      return;
    }
    if (pathname) {
      if (miniLocationIsTabPage(pathname)) {
        switchTab('/pages/' + pathname);
      } else {
        // 直播间的跳转链接不需要前面的pages，是直接的跳转
        if (item.jumpData && item.jumpData.type && item.jumpData.type === 'live') {
          useRedirect ? redirect(pathname + (search || '')) : to(pathname + (search || ''));
        } else {
          useRedirect
            ? redirect('/pages/' + pathname + (search || ''))
            : to('/pages/' + pathname + (search || ''));
        }
      }
    }
  }
}

function miniLocationIsTabPage(link) {
  if (!link) return false;
  link = '/pages/' + link;
  return miniLinkIsTabPage(link);
}

// 判断tab页
export function miniLinkIsTabPage(link) {
  if (!link) return false;
  if (
    link.indexOf('/pages/index') === 0 ||
    link.indexOf('/pages/category') === 0 ||
    link === '/pages/cart' ||
    link.indexOf('/pages/mine') === 0 ||
    link.indexOf('/pages/member-home') === 0
  ) {
    return true;
  }
  return false;
}

// 判断免登陆领奖活动页
function miniLinksActiveyPage(link) {
  if (!link) return false;
  if (link.indexOf('free-login-active') !== -1) {
    return true;
  }
  return false;
}

function toClearPage(linkUrl, useRedirect) {
  if (linkUrl) {
    if (miniLinkIsTabPage(linkUrl)) {
      switchTab(linkUrl);
    } else {
      useRedirect ? redirect(linkUrl) : to(linkUrl);
    }
  }
}

// "jumpData": {
//   "appId": "wxbe31c0570d3e05e2",
//   "miniLink": "/page/index",
//   "type": "custom",
//   "webLink": "/page/h5"
// },
function toOtherAppLocation(item) {
  if (item.jumpData && item.jumpData.type === 'custom') {
    const otherAppId = item.jumpData.appId;
    let miniLink = item.jumpData.miniLink;
    const { extraData } = item.jumpData || {};
    const envVersion = 'release';
    if (!miniLink) {
      miniLink = '';
    }
    if (otherAppId) {
      const jumpParams = {
        appId: otherAppId,
        path: miniLink,
        envVersion: envVersion,
        success(res) {
          // 打开成功
        },
      };
      if (extraData) {
        jumpParams.extraData = extraData;
      }
      uni.navigateToMiniProgram(jumpParams);
    }
  }
}

// 联系客服按钮的bindcontact回调里面对于客服里面跳转的处理
function contactsJump(e) {
  if (e.detail) {
    const path = e.detail.path;
    const query = e.detail.query;
    if (miniLinkIsTabPage(path)) {
      // 表示需要用switchTab去跳转的
      switchTab(path);
    } else {
      let params = '';
      for (const key in query) {
        params = key + '=' + query[key] + '&';
      }
      params = params.slice(0, params.length - 1);
      params ? to(`${path}?${params}`) : to(path);
    }
  }
}
// 登录成功后回跳
function backLoginUrl() {
  const backUrl = uni.getStorageSync('loginBackPath') || '/pages/mine';
  redirect(backUrl);
  uni.removeStorageSync('loginBackPath');
}

/**
 * 处理配置的jumpDesc跳转
 * @param {*} jumpDesc 跳转json字符串数据
 * @param {*} defaultJump 未配置跳转页默认跳转的页面地址，默认不跳转
 * @param {*} defaultJumpTabbar 默认跳转是否为tabbar页面，默认true
 * @param {*} useRedirect 跳转是否关闭当前页面，后退不回当前页面，默认false
 */
function dealJumpData(cfgs = {}) {
  let data;
  const { jumpDesc, useRedirect = false, defaultJump, defaultJumpTabbar = true } = cfgs;

  try {
    data = JSON.parse(jumpDesc);
  } catch (error) {
    data = {};
    console.log(`跳转数据解析异常：${error}`);
  }

  const { jumpData = {} } = data;
  const { appId, type } = jumpData;

  if (!type || type === 'null') {
    // 未配置默认跳转页
    if (!defaultJump) return;
    // 默认跳转页为非tabbar页面
    if (!defaultJumpTabbar) {
      return useRedirect ? redirect(defaultJump) : to(defaultJump);
    }
    // 默认跳转页为tabbar页面
    return switchTab(defaultJump);
  }

  if (!appId) {
    return toLocation(data, useRedirect);
  }



}
export default {
  to,
  back,
  redirect,
  switchTab,
  reLaunch,
  toPage,
  toLocation,
  toClearPage,
  toOtherAppLocation,
  contactsJump,
  backLoginUrl,
  dealJumpData,
};
